import { Skeleton } from '@/components/Skeleton'

import {
  ActionsContainer,
  HeaderContainer,
  SummaryContainer,
  SummaryInnerContainer,
} from '.'

const headerColor = '#D4DDE8'

export const SkeletonHeader = () => (
  <HeaderContainer>
    <Skeleton testId="breadcrumb" width="150px" height="15px" color={headerColor} />
    <SummaryContainer>
      <Skeleton testId="avatar" width="50px" height="50px" color={headerColor} />
      <SummaryInnerContainer>
        <Skeleton testId="name" width="150px" height="34px" color={headerColor} />
        <Skeleton testId="subjectId" width="200px" height="15px" color={headerColor} />
      </SummaryInnerContainer>
      <ActionsContainer>
        <Skeleton
          testId="lastProcessedBy"
          width="150px"
          height="20px"
          color={headerColor}
        />
        <Skeleton
          testId="lastProcessedBy"
          width="200px"
          height="20px"
          color={headerColor}
        />
      </ActionsContainer>
    </SummaryContainer>
  </HeaderContainer>
)
